import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { fadeIn } from "../utils/motion";

const HandCraftCard = ({ img, title, subtitle, index }) => {
  const { t } = useTranslation();
  return (
    <motion.div
      variants={fadeIn("up", "spring", index * 0.5, 1)}
      className="flex md:flex-row flex-col gap-4"
    >
      <img
        src={img}
        alt={title}
        className="md:w-[270px]  h-[250px] rounded-[32px] object-cover"
      />
      <div className="w-full flex justify-between items-center">
        <div className="flex-1 md:ml-[62px] flex flex-col max-w-[650px]">
          <h4 className="font-normal lg:text-[42px] text-[26px] dark:text-white text-Darktext">
            {t(title)}
          </h4>
          <p>{t(subtitle)}</p>
        </div>
      </div>
    </motion.div>
  );
};

export default HandCraftCard;
